import { BRANDS } from "@/data/content";

export const Marquee = () => (
  <div className="overflow-hidden border-y border-xmove-ink/8 bg-white/60 py-5" data-testid="partners-marquee">
    <div className="marquee-track flex items-center gap-14">
      {[...BRANDS, ...BRANDS].map((b, i) => (
        <span key={i} className="flex items-center gap-14 shrink-0">
          <span className="font-display text-xl md:text-2xl font-semibold text-xmove-ink/35 tracking-tight">{b}</span>
          <span className="h-1.5 w-1.5 rounded-full bg-xmove-orange/60" />
        </span>
      ))}
    </div>
  </div>
);
